<template>
    <vx-expandable-card>
        <template v-slot:header>
            Time-zone
        </template>
        <template v-slot:content>
            <vx-selectable
                data-test="time-zone-select"
                :modelValue="props.modelValue"
                @update:modelValue="emit('update:modelValue', $event)"
                :options="timeZonesList"
                size="lg"
                :reduce="option => option.value"
                placeholder="Select a time-zone"
                :clearable="true"
                :disabled="!onCorporate()"
                :error="props.error"
            ></vx-selectable>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { VxExpandableCard, VxSelectable } from '@voxie/frontend-components';
import { computed } from 'vue';
import { useCurrentGroup } from '~/composables/useCurrentGroup';
import timeZones from '~/utils/timeZones';

const props = defineProps({
    modelValue: {
        type: String,
        default: null,
    },
    error: {
        type: [String, Array],
    }
});

const emit = defineEmits(['update:modelValue']);
const { onCorporate } = useCurrentGroup();

const timeZonesList = computed(() => timeZones.map(timeZone => ({
    value: timeZone,
    label: timeZone.split("_").join(" ")
})))
</script>